import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function Splash() {
  return (
    <motion.div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050807]"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      data-testid="splash-screen"
    >
      <motion.div
        initial={{ scale: 0.7, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1, ease: EASE }}
        className="relative"
      >
        <div className="absolute inset-0 -m-12 rounded-full bg-[#34C77B]/20 blur-3xl" aria-hidden />
        <img
          src="/images/revanta-mark.png"
          alt="Revanta Asset Management"
          className="relative w-36 sm:w-48"
          data-testid="splash-logo"
        />
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.5, ease: EASE }}
        className="mt-10 font-display text-xs font-semibold uppercase tracking-[0.55em] text-slate-400 sm:text-sm"
      >
        Asset Management
      </motion.p>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.3, delay: 0.45, ease: EASE }}
        className="mt-6 h-px w-44 bg-gradient-to-r from-transparent via-[#34C77B] to-transparent"
        aria-hidden
      />
    </motion.div>
  );
}
